const dataFrontend = [
  {
    title: "HTML",
    experience: "Experienced",
  },

  {
    title: "CSS",
    experience: "Experienced",
  },

  {
    title: "JavaScript",
    experience: "Intermediate",
  },

  {
    title: "Bootstrap",
    experience: "Experienced",
  },

  {
    title: "Tailwind",
    experience: "Intermediate",
  },

  {
    title: "ReactJs",
    experience: "Experienced",
  },
];

export default dataFrontend;
